export default __webpack_public_path__ + "static/media/Hat.7424c0fb.svg";